import { css } from "@emotion/react";
import { COLORS } from "stylesheets/emotion/vars";

import { ScreenExtraConfig } from "../../utils/types";

export const deSteegStyleMultiScreen = ({ big_screen_enable }: ScreenExtraConfig) => {
    const PRICE_HEADER_WIDTH = big_screen_enable ? "2.5vw" : "3.25vw";

    return css`
        body {
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
                width: 0;
                height: 0;
            }
        }

        .nix18 {
            position: absolute;
            bottom: 0.2vw;
            left: 0.55vw;
            width: 21vw;
            opacity: 1;
            border-radius: 0.5vw;
        }

        .logoSecondary {
            position: absolute;
            bottom: 2.5vw;
            right: 5vw;
            width: 12vw;
            opacity: 1;
            border-radius: 0.5vw;
            transition: transform 0.4s ease, opacity 0.4s ease;
            z-index: 0;
        }

        .logoSecondary.shrink {
            transform: scale(0.65);
            opacity: 0.8;
        }

        .bannerBack {
            width: 17.5%;
            margin-top: 0.55vw;
            position: absolute;
            margin-left: 53.6%;
        }

        .bannerFront {
            width: 19%;
            margin-left: 27.3%;
            margin-top: 0.68vw;
            position: absolute;
        }

        .bannerLogo {
            width: 10vw;
            position: relative;
            margin-top: 0.1vw;
            margin-left: 112.2%;
            z-index: 1000;
            filter: drop-shadow(0vw 0.3vw 0.3vw #000);
        }

        @keyframes rotation {
            0% {
                transform: rotate(0deg) scale(0.5);
                opacity: 0.15;
            }
            5% {
                transform: rotate(180deg) scale(0.5);
                opacity: 0.3;
            }
            10% {
                transform: rotate(360deg) scale(0.5);
                opacity: 0.15;
            }
            100% {
                transform: rotate(360deg) scale(0.5);
                opacity: 0.15;
            }
        }

        @keyframes opacity {
            0% {
                opacity: 0.05;
            }
            50% {
                opacity: 0.2;
            }
            100% {
                opacity: 0.05;
            }
        }

        .menukaart {
            width: 98.5vw;
            height: 100vh;
            gap: ${big_screen_enable ? "0.1vw" : "0.5vw"};
            display: grid;
            padding-left: 0.5vw;
            padding-right: ${big_screen_enable ? "0.1vw" : "1vw"};
        }

        .menu {
            width: 100%;
            height: 45vw;
            margin-top: 2vw;
            padding-right: 0.25vw;
            z-index: 1;
        }

        .backgroundShadow {
            background-color: transparent;
            border-radius: 0vw;
        }

        .info {
            display: flex;
            flex-direction: row-reverse;
            margin-right: 0.75vw;
        }

        .row {
            display: flex;
            align-items: center;
            background-color: transparent;
            border-bottom: 0.07vw solid white;
            height: 2.55vw;
            padding-right: 0.5vw;
            padding-left: ${big_screen_enable ? "0.6vw" : "1vw"};
        }

        .row:nth-child(even) {
            background-color: rgba(255, 234, 0, 0.15);
        }

        .row:nth-child(odd) {
            background-color: rgba(68, 140, 58, 0.19);
        }

        .row:nth-last-child(1) {
            border-bottom-left-radius: ${big_screen_enable ? "0.4vw" : "0.8vw"};
            border-bottom-right-radius: ${big_screen_enable ? "0.4vw" : "0.8vw"};
            border-bottom: none;
        }

        .row:first-child {
            border-top-left-radius: ${big_screen_enable ? "0.4vw" : "0.8vw"};
            border-top-right-radius: ${big_screen_enable ? "0.4vw" : "0.8vw"};
        }

        .rowContent {
            display: flex;
            align-items: center;
        }

        .productkind {
            color: white;
            font-size: 0.5vw;
            margin-top: 0.1vw;
            width: 3vw;
            margin-left: 2vw;
        }

        .banner {
            width: 100%;
            margin-left: 8vw;
            margin-top: 1vw;
            position: relative;
        }

        .bannerAll {
            display: hidden;
            height: 5vh;
        }

        .bannerLogo {
            display: hidden;
        }

        .legendNew {
            display: none;
        }

        .pagebackground {
            background-color: rgba(0, 0, 0, 0.5);
            background-image: url("/images/pricelist/smokeBackground.gif");
            background-repeat: no-repeat;
            background-size: cover;
            background-blend-mode: multiply; /* or lighten, overlay, etc. */
            width: 100vw;
            height: 100vh;
            overflow: hidden;
        }

        .pattern {
            background-image: url("/images/pricelist/deSteegLogoColor.png");
            background-repeat: no-repeat;
            background-size: 30% 35%;
            background-position: center;
            top: 0%;
            position: absolute;
            height: 100%;
            width: 100%;
            opacity: 0.1;
            z-index: 0;
            display: none;
        }

        @font-face {
            font-family: "cordia";
            font-weight: normal;
            font-style: normal;
        }

        .logo {
            position: absolute;
            margin-left: 20%;
            margin-top: -5%;
            width: 20%;
            opacity: 0;
        }

        .marginTopTitle {
            margin-top: -5vw;
        }

        .title,
        .titleNotAtTop {
            font-size: ${big_screen_enable ? "1.42vw" : "1.7vw"};
            font-weight: bold;
            margin-top: ${big_screen_enable ? "0.8vw" : "1vw"};
            margin-bottom: ${big_screen_enable ? 0.6 : -2.1}vw;
            position: relative;
            color: white;
            text-shadow: 0 0 0.04vw #000000, 0 0 0.05vw ${COLORS.deSteegGlow}, 0 0 0.06vw ${COLORS.deSteegGlow},
                0 0 0.07vw ${COLORS.deSteegGlow2}, 0 0 0.08vw ${COLORS.deSteegGlow}, 0 0 0.09vw ${COLORS.deSteegGlow2};
            padding-left: ${big_screen_enable ? "0.5vw" : "1vw"};
        }

        .particles {
            position: absolute;
            margin-left: 50vw;
            width: 15.6vw;
        }

        .btn {
            position: absolute;
        }

        .kindBadge {
            height: ${big_screen_enable ? "0.5vh" : "1vh"};
            width: ${big_screen_enable ? "0.5vw" : "1vw"};
            scale: ${big_screen_enable ? "0.7" : "1"};
            margin-right: ${big_screen_enable ? "0.4vw" : "0.6vw"};
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .nameStar {
            display: flex;
            padding-left: 0.2vw;
        }

        .priceGrid {
            display: flex;
            justify-content: center;
            margin-left: ${big_screen_enable ? "0.15vw" : "0.25vw"};
        }

        .nameprice {
            font-size: ${big_screen_enable ? "0.82vw" : "1vw"};
            line-height: ${big_screen_enable ? "0.85vw" : "0.9vw"}; /* NEW */
            text-transform: uppercase;
            color: white;
            font-weight: bold;
        }

        .description {
            font-size: ${big_screen_enable ? "0.72vw" : "1vw"};
            padding-left: ${big_screen_enable ? "0.24vw" : "0vw"};
            color: #e8e5d7;
        }

        .kind {
            font-size: 0.3vw;
            position: relative;
            margin-left: -2vw;
            margin-top: 0.5vw;
            width: 5vw;
            color: white;
        }

        .priceContainer {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .price {
            font-size: ${big_screen_enable ? "0.8vw" : "1vw"};
            width: ${PRICE_HEADER_WIDTH};
            color: white;
            font-weight: bold;
            text-align: right;
        }

        .priceHeader {
            position: relative;
            font-size: ${big_screen_enable ? "0.8vw" : "1.1vw"};
            margin-top: ${big_screen_enable ? "-1.2vw" : "1.5vw"};
            text-align: right;
            width: ${PRICE_HEADER_WIDTH};
            color: white;
            font-weight: bold;
        }

        .filler {
            flex-grow: 1;
        }

        .extraIcon,
        .flag {
            transform-origin: center;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            filter: drop-shadow(1px 1px 0.4px rgba(0, 0, 0, 1));
        }

        .extraIcon {
            transform: scale(${big_screen_enable ? "1.0" : "1.3"});
            padding-right: ${big_screen_enable ? "0.1vw" : "0.6vw"};
        }

        .extraIcon:first-child {
            padding-left: ${big_screen_enable ? "0vw" : "0.4vw"};
        }

        .stackedIcon {
            margin-left: -0.5vw; /* pulls it closer to the previous */
            position: relative;
        }

        .flag {
            transform: scale(${big_screen_enable ? "1.4" : "1.7"});
            padding-left: ${big_screen_enable ? "0.3vw" : "0.6vw"};
            padding-right: ${big_screen_enable ? "0.25vw" : "0vw"};
        }

        .iconContainer {
            white-space: nowrap; /* Prevent icons from breaking onto a new line */
            display: inline-flex; /* Align icons in a row with the text */
            gap: 0.5vw;
            padding-left: 0.3vh;
        }

        .svg-inline--fa {
            margin-left: 1vw;
            margin-top: 0.4vw;
            font-size: 0.7vw;
        }

        .legend {
            position: absolute;
            bottom: 0vw;
            right: 0vw;
            width: 40vw;
            .container {
                width: 100%;
                .content {
                    display: flex;
                    box-shadow: inset 0 0 128px rgba(0, 0, 0, 0.6);
                    border-radius: 0.5vw;
                    justify-content: center;
                    align-items: center;
                    padding: 0vw;
                    gap: 2vw;

                    .legendRow {
                        display: flex;
                        align-items: center;
                        gap: 0.4vw;

                        .newIcon {
                            position: relative;
                            margin-bottom: 0.3vw;
                        }

                        .label {
                            font-size: 1.2vw;
                            color: white;
                        }
                    }
                }
            }
        }
    `;
};
